import { RootState } from 'editor/src/store/index';

const getSelectedElementUuids = (state: RootState) => state.editor.selectedElementUuids;

export default getSelectedElementUuids;
